import { Component, Inject, NgModule } from '@angular/core';
import { A11yModule } from '@angular/cdk/a11y';
import { CommonModule, AsyncPipe } from '@angular/common';
import { BehaviorSubject, combineLatest, Observable, of, Subject, map, startWith, switchMap, tap } from 'rxjs';
import { UntypedFormControl, UntypedFormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA, MatDialogClose } from '@angular/material/dialog';
import { Alert } from '@uw/core/models/alert.model';
import { ContentService } from '@uw/core/services/content.service';
import { MatButtonModule, MatIconButton } from '@angular/material/button';
import { MatIconModule, MatIcon } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { ProfileStore } from '@uw/modules/profile/profle.store';

@Component({
    selector: 'uw-alert-detail-dialog',
    templateUrl: './alert-detail-dialog.component.html',
    styleUrls: ['./alert-detail-dialog.component.scss'],
    imports: [A11yModule, MatIconButton, MatDialogClose, MatIcon, ReactiveFormsModule, AsyncPipe, TranslateModule]
})
export class AlertDetailDialogComponent {

  private readonly _saveSubject: Subject<Alert> = new Subject();

  private readonly _save$ = this._saveSubject.asObservable();

  private _alertSubject: BehaviorSubject<Alert> = new BehaviorSubject(<Alert>{})

  private _profileIdSubject: BehaviorSubject<any> = new BehaviorSubject(null);

  readonly vm$ = combineLatest([
    this._alertSubject,
    this._profileIdSubject.pipe(
      switchMap(profileId => this._save$.pipe(
        switchMap(alert => this._handleSave(profileId, alert)),
        tap(alert => this._dialogRef.close(alert)),
        startWith(null)))
    )
  ])
    .pipe(
      map(([alert]) => {
        const form = new UntypedFormGroup({
          id: new UntypedFormControl(alert.id, [Validators.required]),
          description: new UntypedFormControl(alert.description, [Validators.required]),
          content: new UntypedFormControl(alert.content, [Validators.required]),
          contentFr: new UntypedFormControl(alert.contentFr, [Validators.required])
        });

        return {
          form
        }
      })
    )

  constructor(
    @Inject(MAT_DIALOG_DATA) private _data: { alert: Alert, profileId: any },
    private readonly _dialogRef: MatDialogRef<AlertDetailDialogComponent>,
    private readonly _contentService: ContentService,
  ) {
    this._alertSubject.next(_data.alert);
    this._profileIdSubject.next(_data.profileId);
  }

  save(alert: Alert) {
    this._saveSubject.next(alert);
  }

  private _handleSave(profileId: any, alert: Alert): Observable<Alert> {
    return this._contentService.updateAlert(profileId, alert)
      .pipe(
        map(_ => alert)
      )
  }
}

@NgModule({
    exports: [
        AlertDetailDialogComponent
    ],
    imports: [
        A11yModule,
        CommonModule,
        ReactiveFormsModule,
        MatDialogModule,
        MatButtonModule,
        MatIconModule,
        TranslateModule,
        AlertDetailDialogComponent
    ]
})
export class AlertDetailDialogModule { }
